module.exports = __webpack_public_path__ + "img/caredokter.9bfdbd85.svg";